import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import RotatingGreeting from "@/components/RotatingGreeting";
import api from "@/lib/api";
import { useMode } from "@/lib/mode";
import { useAuth } from "@/context/AuthContext";
import { Banknote, TrendingUp, Hammer, CalendarClock } from "lucide-react";

const ROUTES = ["/quotidien", "/chantiers", "/tresorerie"];
const eur = (n) => `${Math.round(n || 0).toLocaleString("fr-FR")} €`;

export default function HeyHeader() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [m, setM] = useState(null);
  const [mode] = useMode();
  const show = mode === "atelier" && ROUTES.includes(pathname);

  useEffect(() => {
    if (!show) return;
    const load = () => Promise.all([api.get("/appointments/finance"), api.get("/appointments")]).then(([f, a]) => {
      const today = new Date().toISOString().slice(0, 10);
      const list = a.data || [];
      setM({
        collected: f.data.collectedMonth, forecast: f.data.forecastMonth,
        enCours: list.filter((x) => x.status === "En cours").length,
        rdv: list.filter((x) => (x.startAt || "").slice(0, 10) === today && !["Brouillon", "Envoyé", "Refusé"].includes(x.status)).length,
      });
    }).catch(() => {});
    load();
    window.addEventListener("birdie:changed", load);
    return () => window.removeEventListener("birdie:changed", load);
  }, [show, pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!show) return null;
  const first = (user?.name || "").split(" ")[0] || "toi";
  const date = new Date().toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long" });
  const badges = m ? [
    { cls: "klt-badge-green", icon: Banknote, label: `${eur(m.collected)} encaissés`, id: "collected" },
    { cls: "klt-badge-sky", icon: TrendingUp, label: `${eur(m.forecast)} prévus ce mois`, id: "forecast" },
    { cls: "klt-badge-violet", icon: Hammer, label: `${m.enCours} projet${m.enCours > 1 ? "s" : ""} en cours`, id: "encours" },
    { cls: "klt-badge-pink", icon: CalendarClock, label: `${m.rdv} RDV aujourd'hui`, id: "rdv" },
  ] : [];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-5" data-testid="hey-header">
      <div data-testid="hey-title"><RotatingGreeting name={first} className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight" /></div>
      {pathname !== "/quotidien" && <p className="text-sm text-muted-foreground capitalize mt-0.5">{date}</p>}
      <div className="flex flex-wrap gap-2 mt-3" data-testid="hey-badges">
        {badges.map((b) => { const Icon = b.icon; return <span key={b.id} className={`klt-badge ${b.cls}`} data-testid={`hey-badge-${b.id}`}><Icon className="w-3.5 h-3.5" />{b.label}</span>; })}
      </div>
    </div>
  );
}
